<template>
<div id="form">
  <Message :show="message.msg" :message="message" />
  <div id="login">
    <div id="description">
      <h1>EFOS</h1>
      <p>Bienvenido!</p>
    </div>
    <div id="form">
      <form @submit.prevent="doLogin">
        <label for="email">Correo Electrónico</label>
        <input type="text" id="email" v-model="email" placeholder="correo@dominio.com" autocomplete="off">

        <label for="password">Contraseña</label>&nbsp;
        <i class="fas" :class="[passwordIcon]" @click="hidePassword = !hidePassword"></i>
        <input :type="passwordType" id="password" v-model="password" placeholder="**********" autocomplete="off">

        <button type="submit">Entrar</button>
      </form>
    </div>
  </div>
  <div>
    <b-row>
      <b-col>
        <b-link to="/contact">¡Contactanos!</b-link>
      </b-col>
    </b-row>
  </div>
</div>
</template>

<script>
import Message from '../components/Message';

export default {
    name: 'Login',
    components: {
      Message
    },
    data: function() {
        return {
            email: '',
            password: '',
            hidePassword: true,
            message: {}
        }
    },
    computed: {
      passwordType() {
        return this.hidePassword ? 'password' : 'text'
      },
      passwordIcon() {
        return this.hidePassword ? 'fa-eye' : 'fa-eye-slash'
      }
    },
    methods: {
      doLogin: async function() {
        var vm = this;
        vm.message = {};
        var payload = {
          email: vm.email,
          password: vm.password
        };
        this.$store.dispatch('login', payload)
       .then(() => this.$router.push('/'))
       .catch(err => {
         // console.log(err);
         vm.message = {
           msg: err,
           variant: 'danger',
           dismiss: 4
         }
         vm.password = '';
         vm.email = '';
       });
      },
    }
}
</script>

<style lang="scss" scoped>
  @import '../assets/styles/_login.sass';
</style>